import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import { CollectionPath, SubColPath } from '@typings/collections.enum';
import { useCollection, useDocument } from '@nandorojo/swr-firestore';
import { IAcccountUser, IUser } from '@typings/setting/userType.interface';
import UserAvatar from '@components/dataDisplay/Avatar/UserAvatar';
import { currentUserIDState } from '@atom/setting/user';
import { useRecoilState } from 'recoil';
import {
  loginWithEmail,
  removeAccount,
} from '@store/firebase/user/registerUser';

const ListBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const EmptySec = styled.p`
  color: var(--subTextColor);
  font-size: 12px;
`;

type Props = {
  shape?: 'full' | 'token';
};
function AccountList({ shape = 'token' }: Props) {
  const [currentUid, setCurrentUid] = useRecoilState(currentUserIDState);
  const [blockLogin, setBlockLogin] = useState(false);

  const { data } = useCollection<IAcccountUser>(
    `${CollectionPath.USERS}/${currentUid}/${SubColPath.ACCOUNTS}`,
    {
      listen: true,
      orderBy: ['createdAt', 'desc'],
    },
  );

  const handleLogin = useCallback(async ({ email, password }) => {
    if (!email && !password) return setBlockLogin(!blockLogin);
    const userToken = await loginWithEmail({ email, password });
    setCurrentUid(userToken?.uid);
    if (userToken) location.reload();
  }, []);

  const handleRemoveAccount = useCallback(
    (e, { uid }: { uid: string }) => {
      // 계정에서 삭제만 하고 해당계정으로 이동하기는 막음
      if (confirm('계정을 정말 삭제하시겠습니까?')) {
        if (currentUid)
          removeAccount({ currentUid: currentUid, targetUid: uid });
      } else return;
    },
    [currentUid],
  );

  const list =
    data &&
    data.map((item, i) => {
      return (
        <UserAvatar
          key={item.id}
          uid={item.id}
          noLink
          showEmail
          shape={shape}
          onClick={() =>
            handleLogin({ email: item.email, password: item.password })
          }
          closeClick={(e) => handleRemoveAccount(e, { uid: item.uid })}
        />
      );
    });

  const EmptyMsg = () => {
    return <EmptySec>계정을 추가해 주세요.</EmptySec>;
  };

  const BlockMsg = () => {
    return (
      <EmptySec>
        재 로그인이 필요합니다. <br />
        이메일, 비밀번호를 입력해 주세요.
      </EmptySec>
    );
  };
  const shapeMap = {
    full: (
      <ListBox>
        <UserAvatar
          uid={currentUid || ''}
          noLink
          shape={shape}
          showEmail
          description="현재 유저 | "
        />
        {list && list.length != 0 ? list : <EmptyMsg />}
        {blockLogin && <BlockMsg />}
      </ListBox>
    ),
    token: list,
  };
  return <>{shapeMap[shape]}</>;
}

export default AccountList;
